interface Tab {
  key: string
  label: string
}

interface TabBarProps {
  tabs: Tab[]
  active: string
  onChange: (key: string) => void
}

export function TabBar({ tabs, active, onChange }: TabBarProps) {
  return (
    <div style={{
      display: 'flex', borderBottom: '1px solid #e8ecf4',
      background: '#fff', padding: '0 28px',
    }}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onChange(tab.key)}
          style={{
            padding: '12px 16px',
            fontSize: 13, fontWeight: active === tab.key ? 600 : 400,
            color: active === tab.key ? '#4f46e5' : '#64748b',
            borderBottom: active === tab.key ? '2px solid #4f46e5' : '2px solid transparent',
            background: 'none', borderTop: 'none', borderLeft: 'none', borderRight: 'none', cursor: 'pointer',
            marginBottom: -1, transition: 'color 0.12s',
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
